import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const path = '../oldPages/user-management/manage-settings-saved/index.html';

const links: Record<string, string> = {
  users: '/infoTrac/user-management?act=updated',
};

function UserManagementManageSettingsSaved() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const users = iframeDocument.getElementById('continue');

      if (users) users.addEventListener('click', () => navigate(links.users));
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, []);

  return (
    <iframe ref={iframeRef} title="user-management-manage-settings-saved" src={path} width="100%" height="300px" />
  );
}

export default UserManagementManageSettingsSaved;
